var React = require('react');
var moment = require('moment');
var labels = require('MemberJoinLabels');
var memberTypeChecker = require('../../../../../Scripts/React/MemberTypeChecker.jsx').step5;
var { $simpleSelect, $input, $datePicker } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');
var apiDataConstants = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/apiDataConstants.js');
var selectableData = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableData.jsx');
var selectableDataFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableDataFunctions.jsx');

class Fellowships extends React.Component {
    constructor(props) {
        super(props);

        this.addFellowship = this.addFellowship.bind(this);
        this.deleteFellowship = this.deleteFellowship.bind(this);
        this.getBlankFellowshipRecord = this.getBlankFellowshipRecord.bind(this);
        this.getFellowshipsMarkup = this.getFellowshipsMarkup.bind(this);
        this.getFellowshipTypeDropdownMarkup = this.getFellowshipTypeDropdownMarkup.bind(this);
        this.getFellowshipSubtypeDropdownMarkup = this.getFellowshipSubtypeDropdownMarkup.bind(this);
        this.getInstitutionDropdownMarkup = this.getInstitutionDropdownMarkup.bind(this);
        this.handleCountryChangeForRecord = this.handleCountryChangeForRecord.bind(this);
        this.handleInputChangeForRecord = this.handleInputChangeForRecord.bind(this);
        this.handleOtherInstitutionChangeForRecord = this.handleOtherInstitutionChangeForRecord.bind(this);
        this.handleStateChangeForRecord = this.handleStateChangeForRecord.bind(this);
        this.incrementFellowshipCount = this.incrementFellowshipCount.bind(this);
        this.decrementFellowshipCount = this.decrementFellowshipCount.bind(this);
        this.state = {
            fellowshipCount: this.props.stepState.fellowships.length
        }
    }

    componentDidMount() {
        this.props.loadApiData('fellowshipType');
        this.props.loadApiData('fellowshipSubType');
    }

    incrementFellowshipCount() {
        this.setState((state) => {
            if ((state.fellowshipCount + 1) > 1) {
                document.querySelector('#btnAddFellowship').value = labels.step5.addAdditionalFellowship;
            }
            return { fellowshipCount: state.fellowshipCount + 1 }
        });
    }

    decrementFellowshipCount() {
        this.setState((state) => {
            if ((state.fellowshipCount - 1) < 1) {
                document.querySelector('#btnAddFellowship').value = labels.step5.addFellowship;
            }
            return { fellowshipCount: state.fellowshipCount - 1 }
        });
    }

    getFellowshipsMarkup() {
        return this.props.stepState.fellowships.map(function (item, index) {
            const stateMarkup = this.props.stateFieldIsRequired(item.country) ? [<$simpleSelect key={item.state + ' validate'}
                name="state"
                value={item.state}
                country={item.country}
                selectdatafunction={selectableDataFunctions.getApiStatesFromAllCountries}
                onChange={this.handleStateChangeForRecord}
                data-recordid={item.id}
                validations={[validationFunctions.required]} />, null]
                : [null, <$simpleSelect
                    key={item.state + ' no-validate'}
                    name="state"
                    value={item.state}
                    country={item.country}
                    selectdatafunction={selectableDataFunctions.getApiStatesFromAllCountries}
                    onChange={this.handleStateChangeForRecord}
                    data-recordid={item.id} />];

            return <div key={index}>

                <div className={"field-wrap"}>
                    <label>{labels.step5.country}</label>
                    <$simpleSelect name="country"
                        value={item.country}
                        selectdatafunction={selectableDataFunctions.getApiCountriesFromAllCountries}
                        onChange={this.handleCountryChangeForRecord}
                        data-recordid={item.id}
                        validations={[]} />
                </div>

                <div className={"field-wrap"}>
                    <label>{labels.step5.state}</label>
                    {stateMarkup}
                </div>

                {this.getInstitutionDropdownMarkup(item)}
                {this.getFellowshipTypeDropdownMarkup(item)}
                {this.getFellowshipSubtypeDropdownMarkup(item)}

                <div className={"field-wrap"}>
                    <label>{labels.step5.startDate}</label>
                    <$datePicker
                        value={item.startDate && moment.utc(item.startDate).isValid() ? moment.utc(item.startDate).format('YYYY-MM-DD') : ""}
                        onInput={this.handleInputChangeForRecord}
                        name="startDate"
                        type="date"
                        date-format="yyyy-mm-dd"
                        data-recordid={item.id} comparetodate={item.endDate} validations={[validationFunctions.required, validationFunctions.date]} />
                </div>

                <div className={"field-wrap"}>
                    <label>{labels.step5.endDate}</label>
                    <$datePicker
                        value={item.endDate && moment.utc(item.endDate).isValid() ? moment.utc(item.endDate).format('YYYY-MM-DD') : ""}
                        onInput={this.handleInputChangeForRecord}
                        name="endDate"
                        type="date"
                        date-format="yyyy-mm-dd"
                        data-recordid={item.id} comparetodate={item.startDate} validations={[validationFunctions.required, validationFunctions.date, validationFunctions.dateGreaterThan]} />
                </div>
                <a href="#/" className={"alt-button"} data-recordid={item.id} data-fromapi={item.fromApi} onClick={this.deleteFellowship}>{labels.step5.deleteFellowship}</a>
                <hr className={"divider"} />
            </div>;
        }.bind(this));
    }

    getBlankFellowshipRecord() {
        return {
            id: btoa(Math.random()).substring(0, 12),
            country: '',
            state: '',
            institution: '',
            customInstitution: '',
            programType: 'Fellowship',
            type: '',
            subtype: '',
            startDate: '',
            endDate: ''
        }
    }


    addFellowship() {
        this.props.pushNewRecord('fellowships', this.getBlankFellowshipRecord());
        //this.props.recenterScreen('.fellowships-container');
        this.incrementFellowshipCount();
    }

    deleteFellowship(event) {
        this.props.deleteRecord('fellowships', event.target.dataset.recordid, !event.target.dataset.fromapi);
        this.props.recenterScreen('.fellowships-container');
        this.decrementFellowshipCount();
    }

    getInstitutionDropdownMarkup(fellowship) {
        if (this.props.appState.apiData.institutions && this.props.appState.apiData.institutions.length) {
            const otherInstMarkup = this.props.institutionHasOther(fellowship.institution)
                ? <div className={"field-wrap"}>
                    <label>{labels.step5.otherInstitution}</label>
                    <$input value={fellowship.customInstitution} name="customInstitution" data-recordid={fellowship.id} data-state={fellowship.state} onChange={this.handleOtherInstitutionChangeForRecord} />
                </div> : null;
            return <div className={"field-wrap"}>
                <label>{labels.step5.institution}</label>
                <$simpleSelect
                    name="institution"
                    titlefieldname="InstitutionName"
                    value={fellowship.institution}
                    programtypecode={apiDataConstants.programTypeCodes.fellowship}
                    selectdatafunction={selectableDataFunctions.getInstitutionSelectableOptions}
                    userdefinedstate={fellowship.state}
                    userdefinedcountry={fellowship.country}
                    data-recordid={fellowship.id}
                    onChange={this.handleInputChangeForRecord}
                    validations={this.props.stateFieldIsRequired(fellowship.country) ? [validationFunctions.required] : []} />

                {otherInstMarkup}
            </div>;
        }
    }

    getFellowshipTypeDropdownMarkup(fellowship) {
        return <div className={"field-wrap"}>
            <label>{labels.step5.fellowshipType}</label>
            <$simpleSelect
                value={fellowship.type}
                name="type"
                selectoptions="fellowshipType"
                onChange={this.handleInputChangeForRecord}
                selectdatafunction={selectableDataFunctions.getDescriptionSelectableOptions}
                data-recordid={fellowship.id}
                validations={[validationFunctions.required]} /></div>;
    }

    getFellowshipSubtypeDropdownMarkup(fellowship) {
        return fellowship.type ? <div className={"field-wrap"}>
            <label>{labels.step5.fellowshipSubtype}</label>
            <$simpleSelect
                value={fellowship.subtype}
                name="subtype"
                selectoptions="fellowshipSubType"
                fellowshipcode={fellowship.type}
                onChange={this.handleInputChangeForRecord}
                selectdatafunction={selectableDataFunctions.getFellowshipSubTypeSelectableOptions}
                data-recordid={fellowship.id}
                validations={[validationFunctions.required]} /></div> : null;
    }

    handleInputChangeForRecord(event) {
        this.props.updateStepStateRecord('fellowships',
            event.target.name,
            event.target.value,
            event.target.dataset.recordid);
    }

    handleCountryChangeForRecord(event) {
        this.props.updateStepStateRecord('fellowships',
            event.target.name,
            event.target.value,
            event.target.dataset.recordid);

        this.props.updateStepStateRecord('fellowships',
            'state',
            '',
            event.target.dataset.recordid);

        this.props.updateStepStateRecord('fellowships',
            'institution',
            '',
            event.target.dataset.recordid);
    }

    handleOtherInstitutionChangeForRecord(event) {
        // find the corresponding institution from selectableData.institutions
        if (selectableData.institutions && selectableData.institutions.length) {
            const otherInst = selectableData.institutions.filter((inst) => {
                return inst.InstitutionName && inst.InstitutionName.indexOf(' - OTHER ' + event.target.dataset.state + ' FELLOWSHIP') >= 0;
            });

            if (otherInst && otherInst.length) {
                this.props.updateStepStateRecord('fellowships',
                    'institution',
                    otherInst[0].InstitutionName,
                    event.target.dataset.recordid);
            }
        }

        this.handleInputChangeForRecord(event);
    }

    handleStateChangeForRecord(event) {
        this.handleInputChangeForRecord(event);
        this.props.updateStepStateRecord('fellowships',
            'institution',
            '',
            event.target.dataset.recordid);
    }

    render() {
        if (memberTypeChecker.hideFellowshipFields(this.props.appState.appType)) {
            return null;
        }

        var addFellowshipText;

        if (this.state.fellowshipCount > 0) {
            addFellowshipText = labels.step5.addAdditionalFellowship;
        }

        else {
            addFellowshipText = labels.step5.addFellowship;
        }

        return <div className={"fellowships-container"}>

            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step5.fellowships}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>
                            {this.getFellowshipsMarkup()}
                            <a href="#/" id="btnAddFellowship" className={"button"} onClick={this.addFellowship}>{addFellowshipText}</a>
                        </div>
                    </div>
                </div>
            </div>

        </div>;
    }
}

module.exports = Fellowships;